import { useEffect } from "react";
import { useAuthSession } from "../auth/session";
import { useStoreActions } from "../store/easy-peasy/hooks";

export type { AuthSessionUser as AuthMeUser } from "../auth/session";

/**
 * App-level hook — reads session from AuthSessionProvider (localStorage after login callback).
 */
export function useAuthMe(_options?: { redirectOn401?: boolean }) {
  const setUserFromMe = useStoreActions((actions) => actions.setUserFromMe);
  const query = useAuthSession();

  useEffect(() => {
    const data = query.data;
    if (!data) return;
    const clientId =
      data.client_id ?? data.clientId ?? data.id ?? data.user_id ?? data.userId;
    if (clientId) {
      setUserFromMe({
        id: String(clientId),
        username: data.full_name ?? data.name ?? data.email ?? "",
        email: data.email ?? "",
      });
    }
  }, [query.data, setUserFromMe]);

  return query;
}
